import {
  domNoscriptInject,
  domScriptInjectAsync,
  REACT_APP__GOOGLE_TAG_MANAGER_ID,
  REACT_APP__YANDEX_METRIKA_COUNTER,
} from "@smp/utils";
import { PropsWithChildren, useEffect } from "react";

import { dataLayerPush } from "@/utils/data_layer_push";

export const ProviderGtm = ({ children }: PropsWithChildren<{}>) => {
  useEffect(() => {
    (async () => {
      if (REACT_APP__GOOGLE_TAG_MANAGER_ID) {
        dataLayerPush({ event: "gtm.js", "gtm.start": new Date().getTime() });
        try {
          await domScriptInjectAsync(
            `https://www.googletagmanager.com/gtm.js?id=${REACT_APP__GOOGLE_TAG_MANAGER_ID}`,
          );
          domNoscriptInject(
            `<iframe src="https://www.googletagmanager.com/ns.html?id=${REACT_APP__GOOGLE_TAG_MANAGER_ID}" height="0" width="0" style="display: none; visibility: hidden;"></iframe>`,
            "body",
          );
        } catch {}
      }

      if (REACT_APP__YANDEX_METRIKA_COUNTER) {
        try {
          window.ym =
            window.ym ||
            function () {
              (window.ym.a = window.ym.a || []).push(arguments);
            };
          window.ym.l = Date.now();

          await domScriptInjectAsync(`https://mc.yandex.ru/metrika/tag.js`);
          window.ym(REACT_APP__YANDEX_METRIKA_COUNTER, "init", {
            webvisor: true,
            trackHash: true,
            clickmap: true,
            ecommerce: "dataLayer",
            accurateTrackBounce: true,
            trackLinks: true,
          });
          domNoscriptInject(
            `<div><img src="https://mc.yandex.ru/watch/${REACT_APP__YANDEX_METRIKA_COUNTER}" style="position:absolute; left:-9999px;" alt="" /></div>`,
            "body",
          );
        } catch {}
      }
    })();
  }, []);
  return <>{children}</>;
};
